import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyBd0pzaau_CpPaQgRdoP761E0xZabPJKgY',
  authDomain: 'clone-f8a32.firebaseapp.com',
  projectId: 'clone-f8a32',
  storageBucket: 'clone-f8a32.appspot.com',
  messagingSenderId: '933602471905',
  appId: '1:933602471905:web:d66b06478bc42a25e92ca0',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebase.auth();

export { db, auth };
